module.exports = __webpack_public_path__ + "img/1_Sky_and_city-01.e09a710d.png";